import type { ComponentProps } from "react";

import { PointContactContent } from "@features/point-inner-content/point-contact-content";

import { ContactLink } from "@shared/ui/contact-link";
import { Body } from "@shared/ui/typography";

import type { AccommodationsPointType } from "@/_pages/accommodations/model/types";

import s from "../point-contact-content.module.scss";

export type CompProps = ComponentProps<"div"> & {
  data: AccommodationsPointType;
  isTablet?: boolean;
};

export const AccommodationsContent = (props: CompProps) => {
  const { data, isTablet } = props;

  const addressContent = data.location ? (
    <Body size="uppercase-small" weight="semiBold">
      {data.location}
    </Body>
  ) : null;

  const contactsContent = data.phone ? (
    <div className={s.valueList}>
      <ContactLink type="phone" value={data.phone} className="global-link">
        <Body size="uppercase-small" weight="semiBold">
          {data.phone}
        </Body>
      </ContactLink>
    </div>
  ) : null;

  const workTimeContent =
    data?.workTimeList && data?.workTimeList?.length > 0 ? (
      <div className={s.valueListNoGap}>
        {data.workTimeList.map((item, idx) =>
          item?.timeSlot != null && item.timeSlot !== "" ? (
            <Body
              key={item?.id ?? item?.timeSlot ?? idx}
              size="uppercase-small"
              weight="semiBold"
            >
              {item.timeSlot}
            </Body>
          ) : null,
        )}
      </div>
    ) : null;

  return (
    <PointContactContent
      items={[
        {
          key: "location",
          title: "Адрес",
          iconName: "location",
          iconColor: "cadmium",
          content: addressContent,
        },
        {
          key: "contacts",
          title: "Контакты",
          iconName: "phone",
          iconColor: "violet",
          content: contactsContent,
        },
        {
          key: "worktime",
          title: "Часы работы",
          iconName: "clock",
          iconColor: "azure",
          content: workTimeContent,
        },
      ]}
      siteUrl={data.siteLink}
      mapAnchorId="accommodations-map"
      isTablet={isTablet}
    />
  );
};

AccommodationsContent.displayName = "AccommodationsContent";
